import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTestReports } from "../../../store/slices/fault-module/test-report.slice";
import TestReportTableComponent from "./test-report-table.component";
import TableSort from "../../../shared/helpers/table-sort";
import capitalizeFirst from "../../../shared/helpers/upper-case";
import moment from "moment";

const TestReportComponent = () => {
  const [PageNumber, setPageNum] = useState<number>(1);
  const pageSize = 10;

  const filter = useSelector((state: any) => {
    return state.testReport.filter;
  });

  const [SortBy, setSortBy] = useState<any>(capitalizeFirst("blockCode"));
  const [SortDirection, setSortDirection] = useState<any>("desc");

  const [columns, setColumns] = useState([
    {
      title: "Block Code",
      label: "blockCode",
      isSorted: true,
    },
    {
      title: "Asset ID",
      label: "assetCode",
      width: "16rem",
    },
    {
      title: "Test Date",
      label: "testDate",
      type: "datetime",
    },
    {
      title: "Light Type",
      label: "assetType",
    },
    {
      title: "Test Result",
      label: "testResult",
    },
    {
      title: "Remarks",
      label: "",
    },
  ]);

  const dispatch = useDispatch();

  const testReportData = useSelector((state: any) => {
    return state.testReport.testReports;
  });

  const isLoadingTestReports = useSelector((state: any) => {
    return state.testReport.isLoadingTestReports;
  });

  const onRefetchData = (
    tcCode = null,
    siteCode = null,
    blockCode = null,
    emergencyLight = null,
    startDate = null,
    endDate = null
  ) => {
    setPageNum(1);
    dispatch(
      getTestReports({
        PageNumber: 1,
        pageSize,
        tcCode,
        siteCode,
        blockCode,
        emergencyLight,
        startDate,
        endDate,
        SortBy,
        SortDirection,
      })
    );
  };

  useEffect(() => {
    const { townCouncil, site, block, emergencyLight, startDate, endDate } =
      filter;

    if (townCouncil && site && block && startDate && endDate) {
      dispatch(
        getTestReports({
          PageNumber: PageNumber,
          pageSize,
          tcCode: townCouncil || null,
          siteCode: site || null,
          blockCode: block || null,
          emergencyLight: emergencyLight || null,
          startDate: moment.utc(startDate) || null,
          endDate: moment.utc(endDate) || null,
          SortBy,
          SortDirection,
        })
      );
    }

    // onRefetchData();
  }, [dispatch, PageNumber, SortBy, SortDirection, filter]);

  const isLoading = useSelector((state: any) => state.testReport.isLoading);
  const error = useSelector((state: any) => state.testReport.error);

  const handleChangePage = useCallback((page: number): void => {
    setPageNum(page);
  }, []);

  const handleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setSortBy(sortBy);
      setSortDirection(sortDirection);

      const copyColumns: any = await TableSort(columns, sortBy);
      setColumns(copyColumns);
    },
    []
  );

  return (
    <div>
      <TestReportTableComponent
        columns={columns}
        data={testReportData?.data}
        totalNumberOfRecords={testReportData?.numberOfRecords}
        pageSize={pageSize}
        current={PageNumber}
        onChangePage={handleChangePage}
        onRefetchData={onRefetchData}
        onChangeSort={handleChangeSort}
        isLoading={isLoadingTestReports}
      />
    </div>
  );
};

export default TestReportComponent;
